import axios from 'axios';
import Bouncer from 'formbouncerjs/src/js/bouncer/bouncer';
import Forms from '../components/forms';
export default class NewsletterForm {
    constructor() {
        this.section = document.querySelector('footer');
        this.form = this.section.querySelector('#formNewsletter');
        this.formField = this.form.querySelector('#emailNews');
        this.formCheck = this.form.querySelector('#termsNews');
        // this.errorView = this.form.querySelector('.messageNews');
        this.errorSendForm = this.form.querySelector('.sendFormError');
        this.successView = this.form.querySelector('.newsletterSuccess');
        this.message = this.form.querySelector('#messageNews');
        this.btnSubmit = this.form.querySelector('button');

        this.initRecaptcha();
        this.ready();
    }

    ready() {
        this.btnSubmit.addEventListener('click', () => {
            if (this.formField.value === '') {
                this.formField.focus();
            }
        });

        this.formField.addEventListener('focusout', () => {
            if (this.formField.value != '' && this.formCheck.checked) {
                this.btnSubmit.disabled = false;
            }
        });

        this.formCheck.addEventListener('click', () => {
            if (this.formField.value != '' && this.formCheck.checked) {
                this.btnSubmit.disabled = false;
            }
        });

        new Bouncer(`#formNewsletter`, {
            fieldClass: 'error-field',
            disableSubmit: true,
            ...Forms.wrongMessages(),
        });

        document.addEventListener(
            'bouncerShowError',
            (event) => {
                if (
                    this.formField.classList.contains('error-field') ||
                    this.formCheck.classList.contains('error-field')
                ) {
                    this.btnSubmit.disabled = false;
                    return (this.message.innerHTML = 'Verifique os campos marcados e tente novamente.');
                }
            },
            false
        );

        this.form.addEventListener(
            'bouncerFormValid',
            (event) => {
                event.preventDefault();
                if (event.target.id == this.form.id) {
                    this.sendFormContactAjax(event.target);
                }
            },
            false
        );
    }

    initRecaptcha() {
        this.formField.addEventListener('focus', () => {
            if (!window.grecaptcha) {
                window.loadRecaptchaV3();
            }
        });
    }

    sendFormContactAjax(form) {
        this.btnSubmit.disabled = true;

        const urlForm = form.dataset.action;

        reloadCaptcha('newsletter', 'g-recaptcha-response', () => {
            this.btnSubmit.disabled = true;
            const dataForm = new FormData(form);

            if (this.formCheck.checked) {
                dataForm.set('termsNews', 1);
            } else {
                dataForm.set('termsNews', 0);
            }

            axios({
                method: 'POST',
                url: urlForm,
                data: dataForm,
                headers: { 'Content-Type': 'multipart/form-data' },
                maxRedirects: 0,
            })
                .then((response) => {
                    form.reset();
                    this.btnSubmit.disabled = false;
                    // this.errorView.classList.add('hidden')
                    // this.errorSendForm.classList.add('hidden')
                    // this.successView.classList.remove('hidden')
                    // this.successView.scrollIntoView({ behavior: 'smooth' });
                    form.reset();
                    return (this.message.innerHTML = 'Seu cadastro na newsletter foi um sucesso!');
                })
                .catch((response) => {
                    this.btnSubmit.disabled = false;
                    return (this.message.innerHTML = 'Houve um erro no envio do formulário.');
                });
        });
    }
}

if (document.querySelector('footer')) {
    new NewsletterForm();
}
